import type { SVGProps } from "react";
const SvgLegal01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m10 11.605-4.925 5.781a1.746 1.746 0 1 1-2.461-2.461L8.395 10"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18 10.048 13.048 15M9.952 2 5 6.952M9.333 2.62 5.62 6.333s1.857 2.476 3.714 4.334c1.858 1.857 4.334 3.714 4.334 3.714l3.714-3.714s-1.857-2.477-3.714-4.334S9.333 2.62 9.333 2.62"
    />
    <path
      fill="currentColor"
      d="M11.456 21.636a.75.75 0 1 0 1.31.728L12.112 22zm1.328-.847.656.364zm6.45 1.575a.75.75 0 1 0 1.31-.728L19.89 22zm-.018-1.575.656-.364zm-.828-1.232.49-.567zm-.794-.441-.229.714zm-3.982.441-.49-.567zm.794-.441-.23-.714zM11 21.25a.75.75 0 0 0 0 1.5v-1.5m10 1.5a.75.75 0 0 0 0-1.5v1.5M12.111 22l.656.364.673-1.21-.656-.365-.656-.364-.672 1.21zm7.778 0 .656-.364-.673-1.211-.656.364-.656.364.673 1.211zm-.673-1.211.656-.364c-.341-.614-.593-1.089-.994-1.435l-.49.567-.49.568c.152.132.268.319.662 1.028zM16 19v.75c.873 0 1.142.009 1.365.08l.23-.714.228-.714c-.5-.16-1.053-.152-1.823-.152zm2.388.557.49-.567a3 3 0 0 0-1.055-.588l-.229.714-.229.714c.204.065.385.167.533.295zm-5.604 1.232.656.364c.394-.71.51-.896.662-1.028l-.49-.568-.49-.567c-.401.346-.653.82-.994 1.435zM16 19v-.75c-.77 0-1.323-.009-1.823.152l.229.714.229.714c.223-.071.492-.08 1.365-.08zm-2.388.557.49.568c.148-.128.329-.23.533-.295l-.23-.714-.228-.714a3 3 0 0 0-1.055.588zM11 22v.75h10v-1.5H11z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20 11.636 22 10m-2 4.91L22 16"
    />
  </svg>
);
export default SvgLegal01;
